import React from 'react';
import { capitalizeFirstLetter } from '../../../../../utils/formatString';

const shimmer =
  'relative overflow-hidden before:absolute before:inset-0 before:-translate-x-full before:animate-[shimmer_2s_infinite] before:bg-gradient-to-r before:from-transparent before:via-white/40 before:to-transparent';
interface HeroSectionProps {
  studentDetails: {
    first_name: string;
  };
  isPdfMode?: boolean;
}

const HeroSection: React.FC<HeroSectionProps> = ({ studentDetails, isPdfMode }) => {
  const studentFirstName = capitalizeFirstLetter(studentDetails ? studentDetails?.first_name : '');

  return (
    <>
      <section
        id="hero-section"
        data-pdf-section
        className="w-full flex items-center justify-center bg-transparent"
      >
        <div
          className={`w-full flex flex-col ${isPdfMode ? 'max-w-[500px] gap-0' : 'max-w-[680px] gap-[10px] md:gap-[15px]'}`}
        >
          <p
            className={`text-center font-[625] text-[#ee731b] font-inter ${
              isPdfMode
                ? 'text-[12px] leading-[14px] mt-0 mb-[4px]'
                : 'text-[14px] md:text-[15px] leading-[normal] m-0'
            }`}
          >
            Designed With Your Goals in Mind
          </p>
          <h1
            className={`flex text-center font-semibold font-monaSans ${
              isPdfMode
                ? 'text-[24px] leading-[26px] text-[#000]'
                : 'text-[24px] md:text-[40px] leading-[34px] md:leading-[50px]'
            }`}
          >
            {studentFirstName ? (
              `${studentFirstName}, your personalized fitness journey starts now`
            ) : (
              <div className="flex flex-col items-center w-full px-[40px] md:px-0">
                <div
                  className={`h-[26.5px] md:h-[42.5px] w-full md:w-[680px] bg-gray-200 dark:bg-gray-700 ${shimmer}`}
                />
                <div
                  className={`h-[26.5px] md:h-[42.5px] w-full md:w-[300px] bg-gray-200 dark:bg-gray-700 mt-[15px] ${shimmer}`}
                />
              </div>
            )}
          </h1>
          {isPdfMode ? (
            <div className="text-center text-[#868686] text-[12px] font-inter font-medium mt-[8px]">
              <div className="whitespace-nowrap leading-[18px]">
                Over the next 3 months, we’ll follow a step-by-step plan tailored to your goals -
              </div>
              <div className="whitespace-nowrap">
                built with expert guidance, care, and at a pace that fits your life.
              </div>
            </div>
          ) : (
            <p className="text-center text-[#868686] text-[15px] md:text-[17px] font-medium leading-[28px] md:leading-[30px] m-0">
              Over the next 3 months, we’ll follow a step-by-step plan tailored to your goals -
              built with expert guidance, care, and at a pace that fits your life.
            </p>
          )}
        </div>
      </section>
    </>
  );
};

export default HeroSection;
